import { Component, OnInit, Input } from "@angular/core";
import { FormControl, Validators, FormGroup } from "@angular/forms";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { MessageService } from "primeng/components/common/messageservice";
import { ContactForm } from "./model/contactForm";
import { ContactService } from "./contact.service";
import { PortService } from "../port/port.service";
import { Pays } from "../port/model/pays";
import { IFilterAutoComplete } from "../offrecommerciale/model/IFilterAutoComplete";
import { UserInformaions } from "../common/userinformations";

@Component({
  selector: "app-contact",
  templateUrl: "./contact.component.html",
  styleUrls: ["./contact.component.scss"],
  providers: [MessageService]
})
export class ContactComponent implements OnInit {
  /*  */
  EMPTY_TOKEN = "";
  OPEN_TOKEN = "open";
  MANDATORY_BORDER = "borderMandatory";

  /* Variables */
  contactForm: ContactForm = new ContactForm(
    null,
    null,
    null,
    null,
    null,
    null,
    null
  );
  contactFormOpen: string = this.EMPTY_TOKEN;

  filteredPays: Observable<IFilterAutoComplete[]>;
  paysValue: Pays;
  controlFormAutoComplete = new FormControl();
  defaultPays: Pays = new Pays(60, "FRANCE", "FR");

  borderEmail = this.MANDATORY_BORDER;
  borderMessage = this.MANDATORY_BORDER;

  errorMessage: string;
  form = new FormGroup({
    firstname: new FormControl(),
    lastname: new FormControl(),
    company: new FormControl(),
    email: new FormControl(
      null,
      Validators.compose([Validators.email, Validators.required])
    ),
    message: new FormControl(null, Validators.compose([Validators.required]))
  });

  userInformations: UserInformaions;

  /* Methode principale   */
  constructor(
    private contactService: ContactService,
    private portService: PortService
  ) {}

  ngOnInit() {
    //this.mapService.disableMouseEvent("map-navigator");
    this.getAllPays();
  }

  openContactForm() {
    this.contactFormOpen = this.OPEN_TOKEN;
  }

  closeContactForm() {
    this.contactFormOpen = this.EMPTY_TOKEN;
  }

  reinitView() {
    this.contactForm = new ContactForm(
      null,
      null,
      null,
      null,
      null,
      null,
      null
    );
    this.borderEmail = this.MANDATORY_BORDER;
    this.borderMessage = this.MANDATORY_BORDER;
  }

  /* Récupérer tous les port depuis le référentiel */
  getAllPays() {
    this.portService.getAllPays().subscribe(
      data => {
        this.filteredPays = this.getFilterControler(data);
       
      },
      error => {
        this.errorMessage = <any>error;
      },
      () => {
        this.paysValue = this.defaultPays;
      }
    );
  }

  getFilterControler(
    options: IFilterAutoComplete[]
  ): Observable<IFilterAutoComplete[]> {
    return this.controlFormAutoComplete.valueChanges.pipe(
      startWith<string | IFilterAutoComplete>(""),
      map(value => (typeof value === "string" ? value : value.nom)),
      map(nom => (nom ? this._filter(options, nom) : options.slice()))
    );
  }

  /** START PARTIE PAYS **/
  displayFn(element?: IFilterAutoComplete): string | undefined {
    let valueToDisplay: string = "";
    if (element && element.nom) {
      valueToDisplay =
        element.nom.charAt(0).toUpperCase() +
        element.nom.substr(1).toLowerCase();
    }
    return valueToDisplay;
  }

  private _filter(
    options: IFilterAutoComplete[],
    name: string
  ): IFilterAutoComplete[] {
    const filterValue = name.toLowerCase();
    return options.filter(
      option => option.nom.toLowerCase().indexOf(filterValue) === 0
    );
  }

  onChangeEmail() {
    if (
      this.form.get("email").hasError("email") ||
      this.form.get("email").hasError("required")
    ) {
      this.borderEmail = this.MANDATORY_BORDER;
    } else {
      this.borderEmail = this.EMPTY_TOKEN;
    }
     
  }

  onChangeMessage() {
    if (this.form.get("message").hasError("required")) {
      this.borderMessage = this.MANDATORY_BORDER;
    } else {
      this.borderMessage = this.EMPTY_TOKEN;
    }
   
  }
  /* Envoyer le message s'il n'y a pas d'erreurs */
  sendMessage() {
    if (this.form.valid) {
      this.userInformations.connexionDate = new Date();
      this.contactForm.userInformations = this.userInformations;
      this.contactForm.pays = this.paysValue ? this.paysValue.nom : null;
      this.contactService
        .sendMessageToContact(this.contactForm)
        .subscribe(data => {
          data.messageSended
            ? console.log("envoi du message a réussi")
            : console.log("Une erreur c'est produite lors de l'envoi");
          this.closeContactForm();
          this.reinitView();
        });
    }
  }

  /* stockage des informations de l'utilisateurs pour les envoyer lors d'envoi de message */
  setUserInformations(userInformations: UserInformaions) {
    this.userInformations = userInformations;
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/contact/contact.component.ts